import { useNextRouter } from '@/data/Content/_NextRouter';
import { personMutatorKeyMatcher, useLogin, UserLogon } from '@/data/Content/Login';
import { useLocalization } from '@/data/Localization';
import {
	Box,
	Divider,
	IconButton,
	List,
	ListItem,
	Modal,
	Paper,
	Stack,
	Typography,
} from '@mui/material';
import { useSWRConfig } from 'swr';
import CloseIcon from '@mui/icons-material/Close';
import {
	ModalLoginContentSx,
	ModalLoginFrameSx,
	ModalLoginHeaderIconCloseFrameSx,
	ModalLoginHeaderIconCloseSx,
	ModalLoginRegisterContentSx,
	ModalLoginRegisterTextSx,
	ModalLoginRegisterTitleSx,
	ModalLoginTitleSx,
} from '@/components/content/Cart/parts/ModalLogin/styles/main';
import { SingleLoginForm } from '@/components/blocks/SingleLoginForm';
import { DpBaseButton } from '@/components/blocks/DpBaseButton';

interface ModalLoginProps {
	onClose: () => void;
	onGoRegister: () => void;
}

export const ModalLoginFavorites: React.FC<ModalLoginProps> = ({ onClose, onGoRegister }) => {
	const router = useNextRouter();
	const RouteLocal = useLocalization('Routes');
	const { mutate } = useSWRConfig();
	const { loginSubmit } = useLogin();

	const handleLogin = async (props: UserLogon) => {
		const resp = await loginSubmit(props);
		if ('userId' in resp ?? {}) {
			await router.push(RouteLocal.Cart.route.t());
			await mutate(personMutatorKeyMatcher(''), undefined);
			onClose();
		}
	};

	return (
		<Modal open onClose={onClose}>
			<Paper sx={ModalLoginFrameSx}>
				<Stack direction="row" justifyContent="flex-end" width="100%">
					<IconButton onClick={onClose} sx={ModalLoginHeaderIconCloseFrameSx}>
						<CloseIcon sx={ModalLoginHeaderIconCloseSx} />
					</IconButton>
				</Stack>
				<Typography sx={ModalLoginTitleSx}>
					{'Crea una lista con tus productos favoritos'}
				</Typography>
				<Box sx={ModalLoginContentSx}>
					<Box>
						<Typography sx={{ ...ModalLoginRegisterTitleSx, mb: '4px' }}>
							{'INICIAR SESIÓN'}
						</Typography>
						<SingleLoginForm
							signInButtonLabel="Comprar con mi cuenta"
							forgotPasswordPosition="form"
							onSubmit={handleLogin}
						/>
					</Box>
					<Divider orientation="vertical" />
					<Stack sx={ModalLoginRegisterContentSx}>
						<Box>
							<Typography sx={{ ...ModalLoginRegisterTitleSx, mb: '20px' }}>
								{'CREAR CUENTA'}
							</Typography>

							<Typography sx={ModalLoginRegisterTextSx}>
								{
									'Inicia sesión o comunícate con tu distribuidor dpvale para que puedas registrarte y disfrutar de todos nuestros beneficios.'
								}
							</Typography>

							<List sx={{ ...ModalLoginRegisterTextSx, listStyleType: 'disc', pl: 2 }}>
								<ListItem sx={{ display: 'list-item', p: 0 }}>
									<Typography variant="body1">
										{'Promociones exclusivas y acumula puntos al comprar.'}
									</Typography>
								</ListItem>
								<ListItem sx={{ display: 'list-item', p: 0 }}>
									<Typography variant="body1">
										{'Ve el seguimiento a tu pedido en todo momento.'}
									</Typography>
								</ListItem>
								<ListItem sx={{ display: 'list-item', p: 0 }}>
									<Typography variant="body1">
										{'Realiza devolución o cambio, de manera rápida y fácil.'}
									</Typography>
								</ListItem>
							</List>
						</Box>
						<DpBaseButton
							sx={{
								mb: '19px',
								'&:hover': {
									backgroundColor: '#E8E8E8',
								},
							}}
							variant="secondary"
							onClick={onGoRegister}
						>
							{'Me quiero registrar'}
						</DpBaseButton>
					</Stack>
				</Box>
			</Paper>
		</Modal>
	);
};
